// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, Component, PropTypes } from '../../utils';

let scrollbarSpacerStyle;

const initScrollbarSpacer = () => {
    if (scrollbarSpacerStyle) {
        return;
    }

    const scrollDiv = document.createElement('div');
    scrollDiv.style.width = '50px';
    scrollDiv.style.height = '50px';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    document.body.appendChild(scrollDiv);

    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);

    scrollbarSpacerStyle = document.createElement('style');
    document.head.appendChild(scrollbarSpacerStyle);
    scrollbarSpacerStyle.sheet.insertRule(`.modal-open { margin-right: ${scrollbarWidth}px; }`, 0);
    scrollbarSpacerStyle.sheet.insertRule(`.modal-open .js-scrollbar-spacer { margin-right: ${scrollbarWidth}px; }`, 1);
};

class Modal extends Component {
    componentWillMount() {
        initScrollbarSpacer();
        document.documentElement.classList.add('modal-open');
    }

    componentWillUnmount() {
        document.documentElement.classList.remove('modal-open');
    }

    render() {
        return (
            <div>
                <div className="main-disabled-block" />
                {this.props.children}
            </div>
        );
    }
}
Modal.propTypes = {
    children: PropTypes.node,
};
Modal.defaultProps = {
    children: null,
};

export default Modal;



// WEBPACK FOOTER //
// ./components/Modal/Modal.js